import React from 'react';

import CircularProgress from '@kmx/shared-components/CircularProgress';
import { Text } from '../../components';

class AsyncLoading extends React.Component {
  componentDidMount() {
    window && window.scrollTo(0, 0);
  }
  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.showUnvalidated) {
      return (
        <div className='async-loading'>
        <Text.Display3 className='text-center'>
          We are submitting your request.
        </Text.Display3>
        <CircularProgress size='large' className='m-xl p-t-xl' />
      </div>  
      )
    }
    return (
      <div className='async-loading'>
        <Text.Display3 className='text-center'>
          We are connecting with a partner identity verification service to ensure that we are able to identify you. We want to be sure we
          are honoring requests from <span className='attention-text'>YOU</span>.
        </Text.Display3>
        <CircularProgress size='large' className='m-xl p-t-xl' />
      </div>
    );
  }
}

export default AsyncLoading;
